var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleVoiletBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 0.269531,
    width: 15,
    height: 15,
    rx: 1,
    fill: "#8D8BD3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8359 7.39453H13.2969V4.85547C13.2969 4.70007 13.2351 4.55103 13.1253 4.44115C13.0154 4.33126 12.8663 4.26953 12.7109 4.26953C12.5555 4.26953 12.4065 4.33126 12.2966 4.44115C12.1867 4.55103 12.125 4.70007 12.125 4.85547V7.39453H9.58594C9.43054 7.39453 9.2815 7.45626 9.17162 7.56615C9.06173 7.67603 9 7.82507 9 7.98047C9 8.13587 9.06173 8.2849 9.17162 8.39479C9.2815 8.50467 9.43054 8.56641 9.58594 8.56641H12.125V11.1055C12.125 11.2609 12.1867 11.4099 12.2966 11.5198C12.4065 11.6297 12.5555 11.6914 12.7109 11.6914C12.8663 11.6914 13.0154 11.6297 13.1253 11.5198C13.2351 11.4099 13.2969 11.2609 13.2969 11.1055V8.56641H15.8359C15.9913 8.56641 16.1404 8.50467 16.2503 8.39479C16.3601 8.2849 16.4219 8.13587 16.4219 7.98047C16.4219 7.82507 16.3601 7.67603 16.2503 7.56615C16.1404 7.45626 15.9913 7.39453 15.8359 7.39453Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.26953H1C0.447715 5.26953 0 5.71725 0 6.26953V19.2695C0 19.8218 0.447715 20.2695 1 20.2695H14C14.5523 20.2695 15 19.8218 15 19.2695V16.2695H5C4.44772 16.2695 4 15.8218 4 15.2695V5.26953Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleVoiletBlue);
export default __webpack_public_path__ + "static/media/multiple-voilet-blue.a29229d485093cd65782773f34be104d.svg";
export { ForwardRef as ReactComponent };